import React from 'react';
import SvgIcon from './SvgIcon';

const LeftCircle = (props: CommonIconProps) => {
    return (
        <SvgIcon {...props} id="mdi-arrow-left-circle">
            <path d="M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M18,11H10L13.5,7.5L12.08,6.08L6.16,12L12.08,17.92L13.5,16.5L10,13H18V11Z" />
        </SvgIcon>
    );
};

export default LeftCircle;
